import MuiFade, { type FadeProps } from "@mui/material/Fade";

export type { FadeProps };

export function Fade(props: FadeProps) {
  return <MuiFade {...props} />;
}
